import * as Yup from 'yup';

export default () =>
  Yup.object().shape({
    title: Yup.string(),
    status: Yup.object().shape({
      value: Yup.string(),
    }),
  });
